<template>
  <div style="padding-top: 60px;background: #f5f5f5;">
    <Header class="black"></Header>
    <div class="informateion">
      <h2>消息列表</h2>
      <ul class="infor-list">
        <li class="infor-list-li" v-for="item,index in msgList">
          <ul class="infor-list-items">
            <li class="items-img">
              <img src="../../assets/images/va.png" alt="">
            </li>
            <li>
              <p>
                <span>{{item.msg}}</span>
                <br>
                <span>{{item.addTime | formatDate}}</span>
              </p>
            </li>
            <li class="del" @click="deleteMsg(item.id)">删除</li>
          </ul>
        </li>
      </ul>
      <div class="page">
          <Page :total="total" :page-size="10" @on-change="queryMsgList" :current="listData.pageNo"></Page>
        </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
  import "@/assets/js/common";
  import $ from "jquery";
  import Header from "@/components/Header";
  import Footer from "@/components/Footer";
  import { caseIndex } from "../../fetch/api";
  export default {
      name: "information",
      components: {
        Header,
        Footer
      },
      data(){
        return{
          msgList:[],
          total: 0,
          listData:{
            pageNo:1,
            pageSize: 10
          }
        }
      },
      methods:{
        queryMsgList(pageNo){
          this.listData.pageNo = pageNo || 1;
          caseIndex.msgList(this.listData).then(data=>{
            this.msgList = data.list;
            this.total = data.counts;
          });
        },
        deleteMsg(id){
          caseIndex.deleteMsg({id:id}).then(data=>{
            if(data.status == 1){
              this.queryMsgList(1);
            }
          });
        }
      },
      mounted(){
        caseIndex.apiAccountsetMsgRead().then();
        this.queryMsgList(1);
      }
  }
</script>
<style>
.informateion{
  background: #fff;
  padding: 20px;
  margin: 20px auto;
  width: 1200px;
  min-height:600px;
}
.informateion h2{
  border-bottom: 1px solid #eee;
  padding-bottom: 20px;
}
.infor-list{

}
.infor-list-li{
  height: 102px;
  /* line-height: 102px; */
  border-bottom: 1px solid #eee;
}
.infor-list-items{
  /* margin-left: 20px; */
}
.infor-list-items li{
  float: left;
  margin-left: 20px;
  margin-top: 30px;
}
.infor-list-items li:last-child{
  float: right;
  margin-right: 20px;
  margin-top: 40px;
}
.items-img{
  width: 42px;
  height: 42px;
  margin-top: 30px;
}
.items-img img{
  width: 100%;
}
.del{
  color:#e4393c;
  cursor: pointer;
}
.del:hover{
  opacity: 0.8;
}
.page{
  text-align: center;
  margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// inform.vue?42eefecb